import { gql } from '../../__generated__/gql'

export const SETLIST_SONG_CONTEXT_QUERY = gql(`
  query setlistSongContext($setlistSongId: Int!) {
    setlistSongContext(setlistSongId: $setlistSongId) {
      setlistId
      setlistName
      presetName
      presetId
      presetSongKey
      presetCapo
      presetCharts
    }
  }
`)
